import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationRU from "./locales/ru/ru.json";
import translationEN from "./locales/en/en.json";

const resources = {
  ru: {
    translation: translationRU,
  },
  en: {
    translation: translationEN,
  },
};

export const CODE_LANG = {
  RU: "ru",
  EN: "en",
};
// Default language by domain: wepurplay.com — EN (международная аудитория),
// все остальные домены (wepurplay.ru, in-touch.space, dev) — RU.
// Срабатывает только для НОВЫХ посетителей (когда localStorage пустой).
// Возвращающимся юзерам остаётся их сохранённый выбор.
function detectDomainLang() {
  if (typeof window === "undefined" || !window.location) return CODE_LANG.RU;
  const host = window.location.hostname;
  if (host === "wepurplay.com" || host === "www.wepurplay.com") {
    return CODE_LANG.EN;
  }
  return CODE_LANG.RU;
}

let lang = detectDomainLang();
lang = detectUrlLang(lang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: lang,
    debug: false,
    detection: {
      order: ["localStorage", "cookie", "queryString"],
      cache: ["localStorage", "cookie"],
    },
    react: {
      wait: true,
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
    cookieOptions: { path: "/", sameSite: "strict" },
  });

function detectUrlLang(lang) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const langFromWP = urlSearchParams.get("lang") || "";

  if (
    langFromWP.length > 0 &&
    (langFromWP === CODE_LANG.EN || langFromWP === CODE_LANG.RU)
  ) {
    lang = langFromWP;
    localStorage.setItem("i18nextLng", lang);
  }
  return lang;
}

export default i18n;
